[
  {
    "id": "lendo",
    "name": "Lendo",
    "minAmount": 10000,
    "maxAmount": 800000,
    "minInterest": 4.95,
    "allowsUC": true,
    "allowsBadCredit": true,
    "affiliateUrl": "https://go.adt228.com/t/t?a=1060519344&as=2098779804&t=2&tk=1&epi=pseo",
    "rating": 4.8,
    "description": "Sveriges största låneförmedlare. En ansökan ger bud från 40+ banker – och endast en UC oavsett antal bud."
  },
  {
    "id": "sambla",
    "name": "Sambla",
    "minAmount": 5000,
    "maxAmount": 800000,
    "minInterest": 4.5,
    "allowsUC": true,
    "allowsBadCredit": true,
    "affiliateUrl": "https://go.adt284.net/t/t?a=1923302872&as=2098779804&t=2&tk=1&epi=pseo",
    "rating": 4.7,
    "description": "Har hjälpt över 500 000 svenskar att sänka sin lånekostnad. Jämför 40+ banker med en enda kreditupplysning."
  },
  {
    "id": "enklare",
    "name": "Enklare",
    "minAmount": 5000,
    "maxAmount": 800000,
    "minInterest": 4.5,
    "allowsUC": true,
    "allowsBadCredit": true,
    "affiliateUrl": "https://do.enklare.se/t/t?a=1244647179&as=2098779804&t=2&tk=1&epi=pseo",
    "rating": 4.6,
    "description": "Snabb ansökan online med personliga bud från 30+ svenska banker – helt utan kostnad och med bara en UC."
  },
  {
    "id": "tomly",
    "name": "Tomly",
    "minAmount": 2000,
    "maxAmount": 70000,
    "minInterest": 23.0,
    "allowsUC": false,
    "allowsBadCredit": true,
    "affiliateUrl": "https://go.adt256.com/t/t?a=1934379288&as=2098779804&t=2&tk=1&epi=pseo",
    "rating": 4.0,
    "description": "Kortfristig kredit utan UC för akuta utgifter – snabb ansökan online och ingen bindningstid."
  },
  {
    "id": "enkelfinans",
    "name": "Enkelfinans",
    "minAmount": 5000,
    "maxAmount": 800000,
    "minInterest": 4.95,
    "allowsUC": true,
    "allowsBadCredit": true,
    "affiliateUrl": "https://go.adt228.com/t/t?a=1587476854&as=2098779804&t=2&tk=1&epi=pseo",
    "rating": 4.7,
    "description": "Kostnadsfri lånejämförelse med personliga bud från flera banker – en ansökan och anmärkningar kan accepteras."
  },
  {
    "id": "advisa",
    "name": "Advisa",
    "minAmount": 5000,
    "maxAmount": 800000,
    "minInterest": 4.5,
    "allowsUC": true,
    "allowsBadCredit": true,
    "affiliateUrl": "https://go.adt284.net/t/t?a=1923306192&as=2098779804&t=2&tk=1&epi=pseo",
    "rating": 4.7,
    "description": "En av Sveriges mest etablerade låneförmedlare – fri och personlig rådgivning ingår i ansökan."
  },
  {
    "id": "axo",
    "name": "Axo Finans",
    "minAmount": 5000,
    "maxAmount": 800000,
    "minInterest": 4.95,
    "allowsUC": true,
    "allowsBadCredit": true,
    "affiliateUrl": "https://go.adt267.com/t/t?a=1948981390&as=2098779804&t=2&tk=1&epi=pseo",
    "rating": 4.5,
    "description": "Nordisk låneförmedlare som även kan hjälpa dig med tidigare betalningsanmärkningar."
  },
  {
    "id": "loansse",
    "name": "Loans.se",
    "minAmount": 5000,
    "maxAmount": 800000,
    "minInterest": 4.5,
    "allowsUC": true,
    "allowsBadCredit": true,
    "affiliateUrl": "https://go.adt267.com/t/t?a=1810104150&as=2098779804&t=2&tk=1&epi=pseo",
    "rating": 4.3,
    "description": "Låneförmedlare med fokus på privatlån och billån – bud från flera banker med en enda UC."
  },
  {
    "id": "fairlo",
    "name": "Fairlo",
    "minAmount": 10000,
    "maxAmount": 70000,
    "minInterest": 20.0,
    "allowsUC": false,
    "allowsBadCredit": false,
    "affiliateUrl": "https://go.adt242.com/t/t?a=1433384226&as=2098779804&t=2&tk=1&epi=pseo",
    "rating": 4.6,
    "description": "Digital kontokredit utan UC (använder Bisnode) med flexibel återbetalning och snabb utbetalning."
  },
  {
    "id": "credifi",
    "name": "Credifi",
    "minAmount": 2000,
    "maxAmount": 200000,
    "minInterest": 22.0,
    "allowsUC": false,
    "allowsBadCredit": true,
    "affiliateUrl": "https://go.adt228.com/t/t?a=1673075264&as=2098779804&t=2&tk=1&epi=pseo",
    "rating": 4.3,
    "description": "Digital snabbkredit utan UC (Creditsafe) med utbetalning inom minuter, dygnet runt."
  },
  {
    "id": "lumify",
    "name": "Lumify",
    "minAmount": 2000,
    "maxAmount": 200000,
    "minInterest": 22.0,
    "allowsUC": false,
    "allowsBadCredit": true,
    "affiliateUrl": "https://go.adt246.net/t/t?a=1278835897&as=2098779804&t=2&tk=1&epi=pseo",
    "rating": 4.2,
    "description": "Modern konsumentkredit utan UC med utbetalning inom 15 minuter – även kvällar och helger."
  },
  {
    "id": "flexkonto",
    "name": "Flexkontot",
    "minAmount": 3000,
    "maxAmount": 40000,
    "minInterest": 22.98,
    "allowsUC": false,
    "allowsBadCredit": true,
    "affiliateUrl": "https://go.adt291.com/t/t?a=1177156373&as=2098779804&t=2&tk=1&epi=pseo",
    "rating": 4.3,
    "description": "Löpande kontokredit utan UC – betala i din takt utan bindningstid och med snabba besked."
  },
  {
    "id": "merax",
    "name": "Merax",
    "minAmount": 3000,
    "maxAmount": 40000,
    "minInterest": 21.95,
    "allowsUC": false,
    "allowsBadCredit": true,
    "affiliateUrl": "https://go.adt291.com/t/t?a=1184128142&as=2098779804&t=2&tk=1&epi=pseo",
    "rating": 4.1,
    "effRate": "24,3%",
    "description": "Mindre lån utan UC med BankID-signering, utbetalning direkt och 0 kr i avgifter."
  },
  {
    "id": "finlo",
    "name": "Finlo",
    "minAmount": 5000,
    "maxAmount": 800000,
    "minInterest": 4.95,
    "allowsUC": true,
    "allowsBadCredit": true,
    "affiliateUrl": "https://go.adt231.net/t/t?a=1897775047&as=2098779804&t=2&tk=1&epi=pseo",
    "rating": 4.5,
    "description": "Låneförmedlare som jämför flera banker i en ansökan – anmärkningar kan accepteras och direktutbetalning finns."
  },
  {
    "id": "ekonomen",
    "name": "Ekonomen",
    "minAmount": 5000,
    "maxAmount": 800000,
    "minInterest": 4.95,
    "allowsUC": true,
    "allowsBadCredit": true,
    "affiliateUrl": "https://go.adt267.com/t/t?a=1715408972&as=2098779804&t=2&tk=1&epi=pseo",
    "rating": 4.7,
    "description": "Kostnadsfri lånejämförelse med personliga bud från flera banker – en ansökan, en kreditupplysning."
  },
  {
    "id": "moneezy",
    "name": "Moneezy",
    "minAmount": 1000,
    "maxAmount": 800000,
    "minInterest": 4.95,
    "allowsUC": true,
    "allowsBadCredit": true,
    "affiliateUrl": "https://go.adt228.com/t/t?a=2083789504&as=2098779804&t=2&tk=1&epi=pseo",
    "rating": 4.3,
    "description": "Internationell jämförelsetjänst som matchar din ansökan mot flera svenska kreditgivare från 1 000 kr."
  }
]
